// extracted by mini-css-extract-plugin
export default {"modalWrapper":"MarkScan_modalWrapper__7U+aA","modalWrapper2":"MarkScan_modalWrapper2__gocGQ","loader":"MarkScan_loader__GFuwf","l3":"MarkScan_l3__b8MIe"};